import { render, staticRenderFns } from "./CategoryFormModal.vue?vue&type=template&id=7977e498&scoped=true&"
import script from "./CategoryFormModal.vue?vue&type=script&lang=js&"
export * from "./CategoryFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977e498",
  null
  
)

export default component.exports